import { config } from "@/config";
import { HttpRequestContentTypeEnum } from "@/types/api";
import axios from "axios";

export const chatApiAxios = axios.create({
  baseURL: config.api.chatApi.url,
  headers: {
    "Content-Type": HttpRequestContentTypeEnum.JSON,
  },
});
